const USER_INPUT_BOOLEAN_VALUES_TRUE = ["1", "true", "yes", "on"];
const USER_INPUT_BOOLEAN_VALUES_FALSE = ["0", "false", "no", "off"];

const USER_INPUT_BOOLEAN_VALUES = {
  true: USER_INPUT_BOOLEAN_VALUES_TRUE,
  false: USER_INPUT_BOOLEAN_VALUES_FALSE
};

export { USER_INPUT_BOOLEAN_VALUES };
